import { getAllLayers } from 'pxc-editor-core/helpers/schema';

export default ({ pages, selectedSection }) => {
  if (selectedSection) {
    const { shield } = getAllLayers(selectedSection.shieldId, pages);
    return shield;
  }
  return null;
};
